<template>
<div class="couponList bgc">
    <couponHeader></couponHeader>
    <div class="padding-20">
        <div class="filters">
            <div class="add">
                <el-button type="primary" @click="handleAdd">添加优惠码</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="name" label="优惠码名称"></el-table-column>
                <el-table-column prop="couponcode" label="优惠码"></el-table-column>
                <el-table-column prop="couponvalue" label="优惠价格">
                    <template slot-scope="scope">
                        <span v-if="scope.row.couponusetype == 1">{{scope.row.couponusetypeText}}:{{scope.row.couponvalue}}%</span>
                        <span v-if="scope.row.couponusetype == 2">{{scope.row.couponusetypeText}}:{{scope.row.couponvalue}}元</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isexpire" label="有效期">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isexpire == 1">{{scope.row.isexpire | isexpire}}</span>
                        <span v-if="scope.row.isexpire == 2">{{scope.row.expirebegindate}}至{{scope.row.expireenddate}}</span>
                    </template>
                </el-table-column>
                <!--<el-table-column prop="date" label="二维码">-->
                <!--<template slot-scope="scope">-->
                <!--<div class="imageText">-->
                <!--<img :src="scope.row.url" alt="" v-if="scope.row.url" preview="vliveExtension">-->
                <!--<el-button type="text" size="small" @click="downLoad(scope.row)">下载</el-button>-->
                <!--</div>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column prop="date" label="状态">
                    <template slot-scope="scope">
                        <span :class="status(scope.row.status)">{{scope.row.status | status}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="date" label="已使用/总数（次）">
                    <template slot-scope="scope">
                        <span v-if="scope.row.totalusecount!=0">{{scope.row.currentusecount}}/{{scope.row.totalusecount}}</span>
                        <span v-if="scope.row.totalusecount==0">不限制次数</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120" label-class-name="tr">
                    <template slot-scope="scope">
                        <div class="tr">
                            <el-button @click="handleDisabled(scope.row)" type="text" size="small" v-if="scope.row.status==1">停用</el-button>
                            <el-button @click="handleEnabled(scope.row)" type="text" size="small" v-if="scope.row.status==9">启用</el-button>
                            <i class="separator">|</i>
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" @getList="_getList" ref="page"></page>
        </div>
    </div>
    <couponEdit ref="couponEdit" @getList="_getList"></couponEdit>
</div>
</template>

<script>
import CouponEdit from 'views/marketingCenter/coupon/CouponEdit'
import CouponHeader from 'views/marketingCenter/coupon/components/couponHeader'
import {getVliveCouponList, editVliveCouponStatus} from 'api/api'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {vliveMgtCode} from 'api/enumCode'
export default {
    name: 'couponList',
    data() {
        return {
            total: 0,
            param: {
                kmcinnerid: this.$route.query.id ? this.$route.query.id : '', // id
                kmctype: this.$route.query.kmctype ? this.$route.query.kmctype : '' // 1图文 2报告 3直播 4视频 5专题
            },
            tableData: []
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleAdd() {
            this.$refs.couponEdit.openDialog(Object.assign({}, this.param, {innerid: ''}))
        },
        downLoad(row) {
            // 注意：同源策略  域名/IP
            let a = document.createElement('a')
            a.download = row.name
            a.href = row.url
            a.click()
        },
        handleEnabled(row) {
            let status = 1
            let tip = '启用成功'
            this.$confirm(`确定启用该优惠码`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this._editStatus(row.innerid, status, tip)
            }).catch(() => {})
        },
        handleDisabled(row) {
            let status = 9
            let tip = '停用成功'
            this.$confirm(`确定停用该优惠码`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this._editStatus(row.innerid, status, tip)
            }).catch(() => {})
        },
        handleEdit(row) {
            this.$refs.couponEdit.openDialog(Object.assign({}, this.param, {innerid: row.innerid}))
        },
        handleClick() {

        },
        _editStatus(innerid, status, tip) {
            this.setLoading(true)
            editVliveCouponStatus({
                data: {
                    innerid: innerid,
                    status: status
                },
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getVliveCouponList({
                data: Object.assign({}, this.page, this.param),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {
        status: function (value) {
            for (let i = 0; i < vliveMgtCode.couponStatus.length; i++) {
                if (value === vliveMgtCode.couponStatus[i].code) {
                    return vliveMgtCode.couponStatus[i].name
                }
            }
            return value
        },
        isexpire: function (value) {
            for (let i = 0; i < vliveMgtCode.isexpire.length; i++) {
                if (value === vliveMgtCode.isexpire[i].code) {
                    return vliveMgtCode.isexpire[i].name
                }
            }
            return value
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                for (let i = 0; i < vliveMgtCode.couponStatus.length; i++) {
                    if (value === vliveMgtCode.couponStatus[i].code) {
                        return vliveMgtCode.couponStatus[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([
            'page'
        ])
    },
    components: {
        CouponEdit,
        Page,
        CouponHeader
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.couponList {
    .imageText{
        img{
            width: 30px;
            height: 30px;
            margin-right: 10px;
        }
    }
}
</style>
